module.exports = __webpack_public_path__ + "media/37.5014bff7.ogg";